import { render, staticRenderFns } from "./modalHeader.vue?vue&type=template&id=ce27127a&"
import script from "./modalHeader.vue?vue&type=script&lang=js&"
export * from "./modalHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports